import type { JSX } from 'solid-js'
import { For } from 'solid-js'

export type Slot = { start: string /* HH:mm */; available: boolean }

export const TimeSlotGrid = (props: {
  slots: Slot[]
  value?: string
  onChange: (start: string) => void
}): JSX.Element => (
  <div class="grid grid-cols-3 sm:grid-cols-4 gap-2">
    <For each={props.slots}>
      {(s) => (
        <button
          type="button"
          disabled={!s.available}
          data-selected={props.value === s.start ? 'true' : 'false'}
          onClick={() => props.onChange(s.start)}
          class="h-11 rounded-md border border-border text-sm font-medium hover:border-accent disabled:opacity-30 disabled:pointer-events-none data-[selected=true]:bg-accent data-[selected=true]:text-white data-[selected=true]:border-accent"
        >
          {s.start}
        </button>
      )}
    </For>
  </div>
)
